var baseIndexOf = require('./_baseIndexOf');

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_arrayIncludes.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_arrayIncludes.js
// module chunks = 1